var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPopUp
    ? _c(
        "div",
        { staticClass: "chat-ia-pop-up" },
        [
          _c(
            "div",
            {
              staticClass: "chat-ia-pop-up__icon",
              style: {
                backgroundColor: _vm.dataModule.color || "var(--primary)"
              },
              attrs: {
                "aria-label": _vm.showChat
                  ? "Fechar AAWZ Intelligence"
                  : "Abrir AAWZ Intelligence"
              },
              on: {
                click: function($event) {
                  _vm.showChat = !_vm.showChat
                }
              }
            },
            [
              _c("icon-svg", {
                attrs: {
                  name: _vm.showChat ? "close" : "ia-head",
                  color: "white",
                  size: _vm.showChat ? "28" : "44"
                }
              })
            ],
            1
          ),
          _c("v-slide-y-transition", [
            _vm.showChat
              ? _c(
                  "div",
                  { staticClass: "chat-ia-pop-up-messages" },
                  [
                    _c("TopChatIaPopUp", {
                      attrs: {
                        showChat: _vm.showChat,
                        "show-conversation": _vm.mostrandoHistorico
                      },
                      on: {
                        setShowChat: function($event) {
                          _vm.showChat = !_vm.showChat
                        },
                        setShowConversation: _vm.alternarHistorico,
                        setNewMessage: _vm.novaConversa
                      }
                    }),
                    _c(
                      "div",
                      { staticClass: "chat-ia-pop-up-messages__content" },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.mostrandoHistorico,
                                expression: "!mostrandoHistorico"
                              }
                            ],
                            staticClass:
                              "chat-ia-pop-up-messages__content__chat"
                          },
                          [
                            _c("ChatView", {
                              attrs: {
                                widget: true,
                                "agente-id": _vm.agenteSelecionadoId,
                                "pergunta-inicial": _vm.perguntaInicial,
                                "enviar-pergunta-inicial":
                                  _vm.enviarPerguntaInicial
                              },
                              on: {
                                "agent-change": function($event) {
                                  _vm.agenteSelecionadoId = $event
                                }
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.mostrandoHistorico,
                                expression: "mostrandoHistorico"
                              }
                            ],
                            staticClass: "p-15 chat-ia-pop-up__conversation"
                          },
                          [
                            _vm.mostrandoHistorico
                              ? _c("Conversations", {
                                  on: {
                                    select: _vm.abrirConversa,
                                    "new-conversation": _vm.novaConversa,
                                    delete: _vm.apagarConversa,
                                    rename: _vm.renomearConversa
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }